import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import {
  btnClickConfig,
  btnConfig,
  togglerButtonConfig,
  togglerMatTooltipConfig,
} from 'dg-fab-speed-dial-lib';
import {
  DgNavBarComponent,
  navBarFooterMenuInterface,
  treeConfigInterface,
} from 'dg-nav-bar-lib';
import html2canvas from 'html2canvas';
import { Observable, Subscription } from 'rxjs';
import { AppInitService } from '../../services/app-init.service';
import { AsyncDataService } from '../../services/async-data.service';
import { LoaderService } from '../../services/loader.service';
import { SupportRequestComponent } from '../support-request-module/support-request/support-request.component';
import { MainService } from './main.service';
import { TaggedActionFormComponent } from '../remarks-actions/tagged-action-form/tagged-action-form.component';
import {stringify,parse} from 'flatted';
import { User } from '../header/header.component';
import { WfmsServiceService } from '../WFMS/Service/wfms-service.service';
import { AuthenticationService } from '../../services/authentication.service';
import { broadCastChannelLogout } from 'src/app/app.component';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  //taking Screenshot
  @ViewChild('screen', { static: true }) screen: ElementRef;
  @ViewChild('support', { static: true }) support: ElementRef;
  treeData = [];
  isLoading = false;
  showDevNodes: boolean;
  showTestNodes: boolean;

  loggedInDetails$:Observable<User>=this.authService.loggedInUser$;
  loggedInDetails=null;

  treeConfig: treeConfigInterface = {
    searchTerm: 'privName',
    treeData: null,
    iconTerm: 'privIconName',
    favoriteNodeTerm: 'isChecked',
    // uniqueKeyNameToSelectNode: 'restURL',
  };

  //support Button
  togglerIcon = 'support_request_portal_icon';

  direction = 'top';
  closeListOnItemClick = true;
  isTogglerMiniFab = false;
  isSvgToggler: togglerButtonConfig = {
    isOpenTogglerSvg: true,
    isCloseTogglerSvg: false,
  };
  togglerMatTooltipConfig: togglerMatTooltipConfig = {
    toolTip: 'Support Request',
    position: 'left',
    showDelayDuration: 200,
  };
  buttonList: btnConfig[] = [
    // {
    //   name: 'Self',
    //   icon: 'support_self_icon',
    //   id: 'self',
    //   width: '30px',
    //   height: '30px',
    //   isSvgIcon: true,
    // },
    // {
    //   name: 'Other',
    //   icon: 'support_other_icon',
    //   id: 'other',
    //   width: '30px',
    //   height: '30px',
    //   isSvgIcon: true,
    // },
  ];

  showBreadCrumbInMainView: boolean = false;
  @ViewChild('navBar') navBar: DgNavBarComponent;

  refreshNavDataSubscription: Subscription;
  footerData: navBarFooterMenuInterface = {
    showFooterMenu: true,

    footerMenu: [],
  };
  displayCommunique: any;
  broadCastChannelLogout : BroadcastChannel = new BroadcastChannel("DGGOV_LOGOUT");
  constructor(
    private authService: AuthenticationService,
    public translate: TranslateService,
    private appInitService: AppInitService,
    public loderService: LoaderService,
    private dialog: MatDialog,
    private asyncDataService: AsyncDataService,
    private router: Router,
    private http: HttpClient,
    private mainService: MainService,
    private oauthService: OAuthService,
  
    
  ) {
    //this.translate.setDefaultLang(this.appInitService.language);
    
  
  }

  ngOnInit(): void {
    //this.translate.setDefaultLang(this.appInitService.language);
    this.showDevNodes = this.appInitService?.appConfig?.showDevNodes;
    this.showTestNodes = this.appInitService?.appConfig?.showTestNodes; // this.appInitService?.appConfig?.showTestNodes;
    // this.fetchNavBarData();
    this.fetchNavBarDataOptimized();

    this.footerData.footerMenu = [
      // {
      //   [this.treeConfig.searchTerm]: 'DMS',
      //   [this.treeConfig.iconTerm]: 'mat-school_outline',
      // },
      // {
      //   [this.treeConfig.searchTerm]: 'Support',
      //   [this.treeConfig.iconTerm]: 'mat-help_outline',
      // },
      // {
      //   [this.treeConfig.searchTerm]: 'Reviews',
      //   [this.treeConfig.iconTerm]: 'rate_review',
      // },
    ];
    this.refreshNavDataSubscription = this.mainService.refreshNavData$.subscribe(
      (params: any[]) => this.fetchNavBarDataOptimized(...params)
    );

    this.appInitService.getConfigurableFields().subscribe(() => {
      this.displayCommunique = this.appInitService?.appConfig?.configurableFields?.dashboardCommuniqueEnable;
      console.log('my config', this.displayCommunique);
      // if (
      //   this.displayCommunique != 'N' ||
      //   this.displayCommunique == undefined
      // ) {
      //   let obj = {
      //     [this.treeConfig.searchTerm]: 'Communique',
      //     [this.treeConfig.iconTerm]: 'mat-chat',
      //   };
      //   this.footerData.footerMenu.push(obj);
      // }
    });

    this.refreshNavDataSubscription = this.mainService.refreshNavData$.subscribe(
      (params: any[]) => this.fetchNavBarDataOptimized(...params)
    );

    this.appInitService.getConfigurableFields();
    this.loggedInDetails$.subscribe((data)=>
      {
        this.loggedInDetails=data;
      });
  }

  ngOnDestroy(): void {
    this.refreshNavDataSubscription?.unsubscribe();
  }

  fetchNavBarDataOptimized(
    loadUserPriv = true,
    loadDevNodes = this.appInitService?.appConfig?.showDevNodes,
    loadTestNodes = this.appInitService?.appConfig?.showTestNodes, // this.appInitService?.appConfig?.showTestNodes,
    favChangedData = null
  ) {
    this.mainService
      .getNavData(loadUserPriv, loadDevNodes, loadTestNodes)
      .subscribe(
        ([quickLinksData, userPrivData, devNodesData, testNodesData]) => {
          // quick links
          if (quickLinksData?.length) {
            this.treeData = [];
            this.handleQuickLinksData(
              quickLinksData,
              loadUserPriv,
              favChangedData
            );
          } else {
            let index = favChangedData?.treeData?.findIndex(
              (x) => x.privName === 'Favourites'
            );
            if (index > -1) {
              favChangedData?.treeData?.splice(index, 1);
              this.treeData = [...favChangedData?.treeData];
              this.treeConfig.treeData = [...this.treeData];
            }
          }
          //
          // userPriv
          if (loadUserPriv) {
            if (userPrivData?.length > 0) {
              this.treeData = [...this.treeData, ...userPrivData];
            }
          }
          //
          // devNodes
          if (loadUserPriv) {
            if (devNodesData?.length)
              this.treeData.push({
                privName: 'Connectors',
                privIconName: 'mat-account_tree',
                children: devNodesData,
              });
            //

            // testNodes
            if (testNodesData?.length)
              this.treeData.push({
                privName: 'Dev Utilities',
                privIconName: 'mat-article',
                children: testNodesData,
              });
          }

          this.treeConfig.treeData = [...this.treeData];
          this.treeConfig = { ...this.treeConfig };
        }
      );
  }

  handleQuickLinksData(quickLinksData, privLoaded: boolean, favChangedData) {
    let items = [];
    console.log('Links------------------', quickLinksData);
    console.log(quickLinksData);

    for (const key in quickLinksData)
      if (quickLinksData.hasOwnProperty(key))
        items?.push(quickLinksData?.[key]);
    console.log(items);
    items?.forEach((item) => {
      item[this.treeConfig?.searchTerm] = item?.linkName;
      item[this.treeConfig?.favoriteNodeTerm] = true;
      item.privId = item?.linkId;
      if (item?.children) {
        for (let i = 0; i < item?.children?.length; i++) {
          let temp = item?.children[i];
          temp[this.treeConfig?.searchTerm] = temp?.linkName;
          temp[this.treeConfig?.favoriteNodeTerm] = true;
          temp.privId = temp?.linkId;
          temp.children = [];
        }
      }
    });

    if (privLoaded) {
      this.treeData.push({
        privName: 'Favourites',
        privIconName: 'mat-star',
        children: items,
      });
      // this.getUserPrivNodes();
    } else {
      this.treeData = favChangedData?.treeData;
      let index = this.treeData?.findIndex((x) => x.privName === 'Favourites');
      if (index > -1) {
        this.treeData[0] = {
          privName: 'Favourites',
          privIconName: 'mat-star',
          children: items,
        };
      } else {
        this.treeData = [
          {
            privName: 'Favourites',
            privIconName: 'mat-star',
            children: items,
          },
          ...this.treeData,
        ];
      }
      this.treeConfig.treeData = [...this.treeData];
      this.treeConfig = { ...this.treeConfig };
    }
  }

  onNodeSelect(node: ApiTreeData): void {
    console.log('On Node Select:::::', node);
    if (node.microServiceBaseUrl) {
      let append = '';
      if (node.restURL.includes('?')) {
        append = '&';
      } else {
        append = '?';
      }
      let url = node.microServiceBaseUrl + node.restURL + append;
      if (this.appInitService?.appConfig?.authType == 'jwt') {
        url =
          url +
          'token=' +
          JSON.parse(localStorage.getItem('userAuthToken'))['token'];
        const w: Window = window.open(url, '_blank');
      } else if (this.appInitService?.appConfig?.authType == 'cookie') {
        this.http.get('/security/access-token').subscribe((result) => {
          console.log(result);
          const restemp = result['data'];
          url = url + 'token=' + restemp['token'];
          console.log('Open Url', url);
          window.open(url, '_blank');
        });
      } else if (this.appInitService?.appConfig?.authType == 'oauth2') {
        url = url 
        console.log(this.loggedInDetails)
      if(node)
      {
        if(node.privURL=="Receipt Creation" || node.privURL=="Receipt Search")
        {
          url = url+"userId=" +this.loggedInDetails.employeeVO.uniqueId;
        }
      }
      if(this.oauthService.hasValidAccessToken())
      {
        window.open(url, '_blank');
      }
      else
      {
        location.reload();
      }
      
      }
    } else {
      if (node.restURL != 'BlankPage' && node.restURL.includes('/')) {
        void this.router.navigateByUrl(node.restURL);
      }
      if (node.restURL != 'BlankPage' && node.restURL.includes('http')) {
        //for tfl
        window.open(node.restURL, '_blank');
      }
    }
  }

  @HostListener('window:beforeunload',['$event'])
unloadNotification($event:any)
{
  let url=sessionStorage.getItem("URL");
  if(url!=null && url!=undefined && url!="")
  {
    if(!url.includes("masterUI_2") && !url.includes("audit") && 
    !url.includes("ebilling-2") && !url.includes("payee") &&
  !url.includes("AG")  && !url.includes("deposit") && !url.includes("budget-allotment-manual")
  && !url.includes("snaclaim"))
  {
    this.broadCastChannelLogout.postMessage(
      {
        dgGovLogout: true,
        refresh:true
      }
    );
    localStorage.setItem("logout","logout");
  }
  }
     
  else
  {
    this.broadCastChannelLogout.postMessage(
      {
        dgGovLogout: true,
        refresh:true
      }
    );
    localStorage.setItem("logout","logout");
  }
 
}
  
    
  onFavoritesChange(event: any): void {
    // this.fetchNavBarData(false, event);
    this.fetchNavBarDataOptimized(
      false,
      this.appInitService?.appConfig?.showDevNodes,
      this.appInitService?.appConfig?.showDevNodes,
      event
    );
  }

  onFooterItemClick(event: any): void {
    console.log('footer click', event);
    if (event?.privName == 'DMS') {
      void this.router.navigateByUrl('main/reference-docs');
    } else if (event?.privName === 'Communique') {
      void this.router.navigateByUrl('main/communique');
    } else if (event?.privName === 'Reviews') {
      this.openReviews(false);
    } else {
      this.openSupport(false);
    }
  }
  openReviews(other: boolean) {
    this.dialog.open(TaggedActionFormComponent, {
      width: '75%',
      height: '90%',
      data: {
        from: 'dialog',
        image64: true,
        other: other,
      },
      disableClose: true,
    });
    void html2canvas(this.screen.nativeElement).then((canvas) => {
      this.asyncDataService.setScreenshotString(canvas.toDataURL());
    });
    // this.dialog.open(TaggedActionFormComponent, {
    //   width: '75%',
    //   height: 'auto',
    //   data: {
    //     from: 'dialog',
    //   },
    //   disableClose: true,
    // });
  }
  buttonClick(event: btnClickConfig): void {
    if (event?.item?.id === 'self') {
      this.openSupport(false);
    }
    if (event?.item?.id === 'other') {
      this.openSupport(true);
    }
  }
  OnSkip() {
    const maincontent = document.getElementById('fixed-main');
    maincontent.setAttribute('tabindex', '0');
    if (maincontent) {
      maincontent.focus({ preventScroll: true });
    }
  }
  openSupport(other: boolean): void {
    if (other) {
      this.dialog.open(SupportRequestComponent, {
        width: '75%',
        height: '90%',
        data: {
          from: 'dialog',
          other: other,
        },
        disableClose: true,
      });
    } else {
      this.dialog.open(SupportRequestComponent, {
        width: '75%',
        height: '90%',
        data: {
          from: 'dialog',
          image64: true,
          other: other,
        },
        disableClose: true,
      });
      void html2canvas(this.screen.nativeElement).then((canvas) => {
        this.asyncDataService.setScreenshotString(canvas.toDataURL());
      });
    }
  }
  dragEnded(event): void {
    //console.log('End method::', this.offset(this.support.nativeElement));

    const evt = event.source;
    if (this.offset(this.support.nativeElement).top < 30) {
      evt._dragRef.reset();
    }
    if (this.offset(this.support.nativeElement).top > 600) {
      evt._dragRef.reset();
    }
  }
  dragStarted(event): void {
    //console.log('stated:', this.offset(this.support.nativeElement));
  }
  offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }
}

export class ApiTreeData {
  children: [];
  classsName: string;
  functionName: string;
  parent: null;
  privDesc: string;
  privFontIcon: string;
  privIconName: string;
  privId: number;
  privName: string;
  privURL: string;
  prntPrivId: number;
  restURL: string;
  microServiceBaseUrl: string;
}
